module.exports = __webpack_public_path__ + "media/images/instructions/aws-iam-roles-3-create-policy-name-e5a26db2a038c110e53ef1737e029818.png";